export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13321.9f23db28.jpg";